import { FahrlehrerCh } from '@/src/@types/blinkadmin'
import JsonLd from '@/src/components/elements/JsonLd'

export default function PersonJsonLd({
  name,
  avatar,
  shortDescription,
  shortSentence,
  lessonLanguages,
  locations,
  fullUrl,
}: FahrlehrerCh.TeacherProfile & { fullUrl?: string | null }) {
  const workLocations = locations.map((location) => ({
    '@type': 'Place',
    name: location.name,
    geo: location.coordinates
      ? {
          '@type': 'GeoCoordinates',
          latitude: location.coordinates.latitude,
          longitude: location.coordinates.longitude,
        }
      : undefined,
  }))

  return (
    <JsonLd
      data={{
        '@context': 'https://schema.org',
        '@type': 'Person',
        name,
        url: fullUrl ?? undefined,
        image: avatar?.url,
        description: shortDescription ?? shortSentence ?? undefined,
        jobTitle: 'Fahrlehrer:in',
        knowsLanguage: lessonLanguages.length > 0 ? lessonLanguages : undefined,
        workLocation: workLocations.length > 0 ? workLocations : undefined,
      }}
    />
  )
}
